import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=ade8a2d2&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=ade8a2d2&prod&lang=scss"
import style1 from "./Wallet.vue?vue&type=style&index=1&id=ade8a2d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade8a2d2",
  null
  
)

export default component.exports